"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _constants = require("../../../constants");
const InfoPrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  transform: "translate(4.000000, 4.000000)"
}, _react.default.createElement("rect", {
  x: "0",
  y: "0",
  width: "16",
  height: "16",
  rx: "3"
}), _react.default.createElement("path", {
  d: "M9,10 L10,10 L10,12 L6,12 L6,10 L7,10 L7,8 L6,8 L6,6 L9,6 L9,10 Z M7,5 L7,3 L9,3 L9,5 L7,5 Z",
  fill: "#FFFFFF"
}))));
const InfoMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("path", {
  d: "M21,0 L3,0 C2.44771525,0 2,0.44771525 2,1 L2,23 C2,23.5522847 2.44771525,24 3,24 L21,24 C21.5522847,24 22,23.5522847 22,23 L22,1 C22,0.44771525 21.5522847,0 21,0 Z M13.028,18.724 L10.963,18.724 L10.963,9 L13.028,9 L13.028,18.724 Z M12.857,7.259 C12.6267272,7.46988411 12.3206576,7.57816346 12.009,7.559 C11.6916415,7.5802264 11.3792188,7.47199684 11.143,7.259 C10.9339666,7.03443684 10.8256149,6.73430267 10.843,6.428 C10.8217402,6.1145502 10.93021,5.80613453 11.143,5.575 C11.3796313,5.36270236 11.6917499,5.25457812 12.009,5.275 C12.3205599,5.25653058 12.6263667,5.36471697 12.857,5.575 C13.06979,5.80613453 13.1782598,6.1145502 13.157,6.428 C13.1743851,6.73430267 13.0660334,7.03443684 12.857,7.259 Z"
})));
const AbstractInfo = ({
  theme,
  fill = '#fff',
  ...other
}) => theme.name === _constants.THEMES.mds ? _react.default.createElement(InfoMDS, (0, _extends2.default)({
  fill: fill
}, other)) : _react.default.createElement(InfoPrizm, (0, _extends2.default)({
  fill: fill
}, other));
var _default = exports.default = (0, _styledComponents.withTheme)(AbstractInfo);